import React from "react";
import { HouseLine } from "phosphor-react";
import { HeaderComp } from "./style";
import { Link } from "react-router-dom";
import BasicButtonExample from "./mobile";

export default function Header() {
  return (
    <HeaderComp>
      <div className="desk">
        <a href="#home">
          <HouseLine className="icon" />
        </a>
        <ul>
          <a href="#services">
            <li id="menu-home">Serviços</li>
          </a>
          <Link to="/about">
            <li id="menu-home">Sobre Nós</li>
          </Link>
          <a href="#faq">
            <li id="menu-home">Perguntas Frequentes</li>
          </a>
          <a href="#testimonials">
            <li id="menu-home">Depoimentos</li>
          </a>
          <a href="#contact">
            <li id="menu-home">Contatos</li>
          </a>
        </ul>
      </div>

      <div className="mob">
        <BasicButtonExample />
        {/* <ul className="menu-list">
          <li id="menu-home">
            <a href="#home">Início</a>
          </li>
          <li id="menu-home">
            <a href="#services">Serviços</a>
          </li>
          <Link style={{textDecoration: 'none', color:'black'}} to="/about">
            <li id="menu-home">Sobre Nós</li>
          </Link>
          <li id="menu-home">
            <a href="#faq">Perguntas Frequentes</a>
          </li>
          <li id="menu-home">
            <a href="#testimonials">Depoimentos</a>
          </li>
          <li id="menu-home">
            <a href="#testimonials">Contatos</a>
          </li>
        </ul> */}
      </div>
    </HeaderComp>
  );
}
